var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'container': _vm.isShowContainer },attrs:{"id":"app"}},[(_vm.$store.state.LOADING)?_c('div',{staticClass:"app-loading"},[_c('van-loading',{attrs:{"type":"spinner","color":"#1989fa"}})],1):_vm._e(),_c('router-view'),_c('AudioPlayer',{attrs:{"hidden":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }